"use strict";

module.exports = {
  IDLE_MINUTES_KEY: 'RSS:IDLE:MINUTES',
  IDLE_TIMEOUT_KEY: 'RSS:IDLE:TIMEOUT',
  IDLE_SIGNOUT_KEY: 'RSS:IDLE:SIGNOUT'
};